import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddressComponent} from './address/address.component';
import {AddressListComponent} from './address-list/address-list.component';
import {AddressAddComponent} from './address-add/address-add.component';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";

@NgModule({
  declarations: [
    AddressComponent,
    AddressListComponent,
    AddressAddComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxIntlTelInputModule
    ],
  exports:[
	AddressComponent,
    AddressListComponent,
    AddressAddComponent
  ]
})
export class AddressModule { }
